import type { AccountingHealth } from "@/api/accounting";

type Props = {
  health: AccountingHealth | null;
  loading?: boolean;
  error?: string | null;
  onViewRequirements?: () => void;
};

function summarizeIssues(health: AccountingHealth) {
  const missing = health.missing.length;
  const shopify = Object.values(health.shopify).reduce((acc, issue) => acc + issue.issues.length, 0);
  const bank = Object.values(health.bank).reduce((acc, issue) => acc + issue.issues.length, 0);
  const events = Object.values(health.events).reduce((acc, issue) => acc + issue.issues.length, 0);
  const total = missing + shopify + bank + events;
  if (total === 0) {
    return "Mappings require review.";
  }
  if (total === 1) {
    return "1 mapping needs attention.";
  }
  return `${total} mappings need attention.`;
}

export function MappingHealthBanner({ health, loading, error, onViewRequirements }: Props) {
  if (loading || !health || health.ok) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-destructive/40 bg-destructive/10 p-4 text-sm text-destructive">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-destructive">Accounting health</p>
          <p className="text-sm text-destructive/80">
            {error ? "Unable to load full mapping status." : summarizeIssues(health)}
          </p>
        </div>
        {onViewRequirements && (
          <button
            type="button"
            onClick={onViewRequirements}
            className="rounded-full border border-destructive/60 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-destructive transition hover:border-destructive hover:text-foreground"
          >
            View mapping requirements
          </button>
        )}
      </div>
    </div>
  );
}
